import { render } from "./registrationSuccessPage.vue?vue&type=template&id=607d8d58&scoped=true"
import script from "./registrationSuccessPage.vue?vue&type=script&lang=js"
export * from "./registrationSuccessPage.vue?vue&type=script&lang=js"

import "./registrationSuccessPage.vue?vue&type=style&index=0&id=607d8d58&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-607d8d58"]])

export default __exports__